import React from "react";
import { Check } from "lucide-react";

export function SingleChoice({ q, value, onChange }) {
  return (
    <div className="grid gap-3" data-testid={`q-${q.id}-options`}>
      {q.options.map((o) => (
        <button type="button" key={o.id} onClick={() => onChange(o.id)} className="st-option" data-active={value === o.id} data-testid={`q-${q.id}-opt-${o.id}`}>
          <span className="st-radio" />
          <span>
            <span className="block font-semibold text-[15px] leading-snug">{o.label}</span>
            {o.detail && <span className="block st-muted text-sm mt-1 leading-relaxed">{o.detail}</span>}
          </span>
        </button>
      ))}
    </div>
  );
}

export function MultiChoice({ q, value, onChange }) {
  const sel = value || [];
  const full = sel.length >= q.max;
  const toggle = (id) => {
    if (sel.includes(id)) onChange(sel.filter((x) => x !== id));
    else if (!full) onChange([...sel, id]);
  };
  return (
    <div>
      <p className="st-caps mb-3" data-testid={`q-${q.id}-counter`}>{sel.length} of {q.max} chosen{full ? " · deselect to change" : ""}</p>
      <div className="grid gap-3 sm:grid-cols-2">
        {q.options.map((o) => {
          const active = sel.includes(o.id);
          return (
            <button type="button" key={o.id} onClick={() => toggle(o.id)} disabled={!active && full} className="st-option" data-active={active} data-testid={`q-${q.id}-opt-${o.id}`}>
              <span className="st-radio st-check">{active && <Check size={13} color="#0B0E13" strokeWidth={3} />}</span>
              <span className="font-semibold text-[15px] leading-snug">{o.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function Pairwise({ q, value, onChange }) {
  const v = value || {};
  return (
    <div className="space-y-4">
      {q.pairs.map((p, i) => (
        <div key={p.id} className="st-panel-2 p-4" data-testid={`q-${q.id}-pair-${p.id}`}>
          <p className="st-caps mb-3">Comparison {i + 1} of {q.pairs.length}</p>
          <div className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-3">
            <button type="button" onClick={() => onChange({ ...v, [p.id]: "a" })} className="st-option justify-center text-center" data-active={v[p.id] === "a"} data-testid={`q-${q.id}-pair-${p.id}-a`}>
              <span className="font-semibold">{p.a.label}</span>
            </button>
            <span className="st-faint text-xs font-bold text-center">vs</span>
            <button type="button" onClick={() => onChange({ ...v, [p.id]: "b" })} className="st-option justify-center text-center" data-active={v[p.id] === "b"} data-testid={`q-${q.id}-pair-${p.id}-b`}>
              <span className="font-semibold">{p.b.label}</span>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export function ScaleQ({ q, value, onChange }) {
  const steps = Array.from({ length: q.max - q.min + 1 }, (_, i) => q.min + i);
  return (
    <div>
      <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0,1fr))` }} data-testid={`q-${q.id}-scale`}>
        {steps.map((s) => (
          <button type="button" key={s} onClick={() => onChange(s)} data-testid={`q-${q.id}-scale-${s}`}
            className="rounded-xl py-4 font-bold text-base transition-all"
            style={value === s ? { background: "var(--st-grad)", color: "#0B0E13", transform: "translateY(-2px)", boxShadow: "0 10px 30px -14px rgba(200,247,74,.8)" }
              : { background: "rgba(243,239,230,.04)", border: "1px solid var(--st-line)", color: "var(--st-text)" }}>{s}</button>
        ))}
      </div>
      <div className="flex justify-between st-faint text-xs mt-3"><span>{q.left_label}</span><span>{q.right_label}</span></div>
    </div>
  );
}
